module.exports = __webpack_public_path__ + "img/elefant_V2_2.a8edf96.jpg";